import { Tooltip } from '@mui/material';
import { useConfig } from 'src/core/config';

interface LogoSignProps {
  /** Logo width. Defaults to '80%' */
  width?: string | number;
}

function LogoSign({ width = '80%' }: LogoSignProps) {
  const { name, description, assets } = useConfig();
  const tooltipTitle = description ? `${name} - ${description}` : name;

  return (
    <Tooltip 
      title={tooltipTitle} 
      arrow
      style={{
        paddingTop: '20px',
        paddingBottom: '20px',
        paddingLeft: '10px',
        paddingRight: '10px'
      }}
    >
      <img
        alt={`${name} Logo`}
        width={width}
        src={assets.logo}
      />
    </Tooltip>
  );
}

export default LogoSign;

